import { SOGetTopic } from '../topic/so-get-topic';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostMessage {

  constructor(
    public name: string,
    public organization: SOGetOrganization,
    public description: string = "",
    public topic: SOGetTopic = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostMessage(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'topic' in params ? params.topic : null,
      'organization' in params ? params.organization : null,
    );
  }
}
